import { call, put, takeLatest } from 'redux-saga/effects'
import {
  LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE,
  LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE,
  LIBRARY_PROMO_CANCEL_DEACTIVATE,
  LIBRARY_PROMO_CANCEL_DELETE,
  LIBRARY_PROMO_CANCEL_REACTIVATE,
  LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO,
  LIBRARY_PROMO_DEACTIVATE_PROMO,
  LIBRARY_PROMO_DELETE_PROMO,
  LIBRARY_PROMO_GET_LIST_PROMO_REQUEST,
  LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION,
  LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_CHANGE_KEYWORD,
  LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES,
  LIBRARY_PROMO_ON_CHANGE_STATUS,
  LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO,
  LIBRARY_PROMO_ON_CLICK_CREATE_PROMO,
  LIBRARY_PROMO_ON_CLICK_DEACTIVATE,
  LIBRARY_PROMO_ON_CLICK_DELETE,
  LIBRARY_PROMO_ON_CLICK_REACTIVATE,
  LIBRARY_PROMO_ON_CLICK_ROW,
  LIBRARY_PROMO_ON_CONFIRM_UPDATE,
  LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_REACH_BUTTOM,
  LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM,
  LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM,
  LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM,
  LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM,
  LIBRARY_PROMO_PAGE_REQUEST,
  LIBRARY_PROMO_REACTIVATE_PROMO,
  LIBRARY_PROMO_SEARCH_OUTLET,
  LIBRARY_PROMO_SELECT_ALL_OUTLETS,
  LIBRARY_PROMO_UNSELECT_ALL_OUTLETS,
  LIBRARY_PROMO_UPDATE_PROMO
} from 'actions/library/promo/constants'
import * as apiPromo from 'api/libraries/promo'
import { showPageLoadingSpinner } from 'actions/loadingSpinner'
import * as actPromo from 'actions/library/promo'
import * as apiOutlets from 'api/outlets'
import * as act from 'actions'
import { change, initialize, reset, stopSubmit } from 'redux-form'
import * as _ from 'lodash'
import moment from 'moment'
import * as actNotif from 'actions/notifications'

export function* fillFormPromoTypeAndName () {
  yield put(initialize('promoTypeAndName', {
    promoType: 'Buy X Get Y', // must match the value to the promo type name
    promoName: '',
    assignedOutlets: []
  }))
}

export function* fillFormAssignOutlet (outlets) {
  let form = {
    selectedOutlets: outlets.map(outlet => {
      return {
        id: outlet.id,
        name: outlet.name,
        checked: false,
        show: true
      }
    })
  }
  yield put(initialize('promoAssignOutlet', form))
}

export function* fillFormReward () {
  yield put(initialize('reward', {
    rewardType: 'freeItem',
    relation: 'AND',
    discountAmount: null,
    discountType: true  // true = percentage, "" = Rp
  }))
}

export function* fillFormPromoConfig () {
  let start = moment().add(1, 'days').startOf('day').toISOString()
  let end = moment().add(2, 'days').endOf('day').toISOString()
  yield put(initialize('promoConfig', {
    isAppliesToMultiple: false,
    isHaveTimePeriod: false,
    days: [null, null, null, null, null, null, null],
    hoursFrom: moment().startOf('day'),
    hoursTo: moment().endOf('day'),
    date: {
      startDate: start,
      endDate: end
    }
  }))
}

export function* initialSearchForm () {
  yield put(initialize('search', {
    'promoType': '0',
    'promoStatus': '0',
    'search': null
  }))
}

export function* resetSelectedOutlets (outlets) {
  let selectedOutlets = outlets.map(outlet => {
    return {id: outlet.id, name: outlet.name, checked: false, show: true}
  })
  yield put(actPromo.setSelectedOutlets(selectedOutlets))
}

export function* pageRequest () {
  yield put(act.showProgressBar())
  yield put(actPromo.setListPromo([]))
  yield put(showPageLoadingSpinner(true))   // set false by listPromoRequest saga
  yield put(actPromo.closeRightColumn())
  yield put(actPromo.setAccordionActiveKey('1'))
  yield put(actPromo.setDetailPromo(null))
  yield put(reset('search'))

  try {
    // call api outlets
    let response = yield call(apiOutlets.outlets)
    yield put(actPromo.setOutlets(response.data))

    const {data} = yield call(apiPromo.getAllPromoTypes)
    yield put(actPromo.setPromoTypes(data))
    /**
     * We need to hashed the outlets for manager
     * Example, if the promo is assigned to 1 outlet, then do not display it
     * Otherwise, display it
     */
    const hashedOutlet = _.mapKeys(response.data, 'id')
    yield put(actPromo.getListPromo({page: 0, per_page: 50}, hashedOutlet))

    // Initialize default action bar
    yield call(initialSearchForm)
  } catch (error) {

  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* clickCreatePromo (request) {
  let {payload: {outlets}} = request
  const isSubmittedPromoForm = {
    promoTypeAndName: false,
    purchaseRequirement: false
  }
  yield put(actPromo.setPrevAssignedOutlets(null))
  yield put(actPromo.setDetailPromo(null))
  yield put(actPromo.setAccordionActiveKey('1'))
  yield put(actPromo.setIsSubmittedPromoForm(isSubmittedPromoForm))
  yield put(actPromo.openRightColumn())
  yield put(reset('promoAssignOutlet'))

  yield call(fillFormPromoTypeAndName)
  yield call(fillFormAssignOutlet, outlets)
  yield call(resetSelectedOutlets, outlets)
}

export function* clickCancel () {
  yield put(actPromo.closeRightColumn())
  yield put(actPromo.setAccordionActiveKey(1))
  yield put(actPromo.setDetailPromo(null))
  yield put(actPromo.setPrevAssignedOutlets(null))
}

// TODO refactor this code. don't use redux form to increase performance
// currently need 2-3 seconds to show popup when outlets about 200
export function* clickAssignOutlet (request) {
  const {payload: {previousSelectedOutlets, selectedOutletsForm}} = request
  yield put(actPromo.setSelectedOutlets(previousSelectedOutlets))
  yield put(change('promoTypeAndName', 'assignedOutlets', previousSelectedOutlets))
  yield put(actPromo.showPromoAssignOutletModal())
  for (let idx = 0; idx < selectedOutletsForm.length; idx++) {
    yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].show`, true))
    if (previousSelectedOutlets.length > 0 && previousSelectedOutlets[idx]) {
      yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, previousSelectedOutlets[idx].checked))
    }
  }
}

export function* searchOutletOnModal (request) {
  const {payload: {outlets, searchKeyword}} = request
  for (let idx = 0; idx < outlets.length; idx++) {
    let res = outlets[idx].name.search(new RegExp(searchKeyword, 'i'))
    if (res !== -1) {
      yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].show`, true))
    } else {
      yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].show`, false))
    }
  }
}

export function* clickCancelModal (request) {
  let {payload: {previousSelectedOutlets}} = request
  yield put(actPromo.hidePromoAssignOutletModal())
  yield put(change('promoTypeAndName', 'assignedOutlets', []))
  for (let idx = 0; idx < previousSelectedOutlets.length; idx++) {
    if (previousSelectedOutlets.length > 0 && previousSelectedOutlets[idx]) {
      yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, previousSelectedOutlets[idx].checked))
    }
    yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].show`, true))
  }
}

export function* selectAllOutletsModal (request) {
  let {payload: {allOutletsForm}} = request
  let {selectedOutlets} = allOutletsForm
  for (let idx = 0; idx < selectedOutlets.length; idx++) {
    if (selectedOutlets[idx].show) {
      yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, true))
    }
  }
}

export function* unselectAllOutletsModal (request) {
  let {payload: {allOutletsForm}} = request
  let {selectedOutlets} = allOutletsForm
  for (let idx = 0; idx < selectedOutlets.length; idx++) {
    if (selectedOutlets[idx].show) {
      yield put(change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, false))
    }
  }
}

export function* confirmAssignOutlet (request) {
  let {payload: {assignedOutlets: {selectedOutlets}}} = request
  yield put(actPromo.setSelectedOutlets(selectedOutlets))
  yield put(change('promoTypeAndName', 'assignedOutlets', selectedOutlets))
  yield put(actPromo.hidePromoAssignOutletModal())
}

// TODO: Please remove this code during refactor time
export function* onSubmitEachPromoFormFlow (request) {
  let {payload: {oldPromoForm, promoFormName, isSubmitted}} = request
  let newIsSubmitted = {...oldPromoForm}
  newIsSubmitted[promoFormName] = isSubmitted
  yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted))
}

// This function will be executed if users select Buy X Get Y
export function* onSubmitFirstForm (request) {
  const {outlets, formName, oldPromoForm, detailPromo, isOutletDifferent} = request.payload
  try {
    if (!isOutletDifferent) {
      yield put(actPromo.setPrevAssignedOutlets(outlets))
    }

    yield put(actPromo.setIsSubmittingForm(true))
    if (!detailPromo || isOutletDifferent) {
      const responses = yield call(apiPromo.getIntersectedItemAndCategories, outlets)
      yield put(actPromo.setIntersectItems(responses.data.items))
      yield put(actPromo.setIntersectCategories(responses.data.categories))
    }
  } catch (e) {
    // TODO Insert notification code here
  } finally {
    yield put(actPromo.setIsSubmittingForm(false))

    // display check or cross button
    let newIsSubmitted = {...oldPromoForm}
    newIsSubmitted[formName] = true
    yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted))

    // if not in update mode, initialize with this data
    // don't initialize second form if it was submitted so that saved data is not resetted after previous
    if (!detailPromo && !oldPromoForm.purchaseRequirement) {
      // Initialize second step of promo form
      yield put(initialize('purchaseRequirement', {
        purchaseType: 'buyFromItem',
        relation: 'AND'
      }))
    }
    // show second accordion form
    yield put(actPromo.setAccordionActiveKey('2'))
  }
}

export function* onSubmitSecondForm (request) {
  const {payload: {formName, oldPromoForm, detailPromo}} = request
  try {
    yield put(actPromo.setIsSubmittingForm(true))
  } catch (err) {

  } finally {
    yield put(actPromo.setIsSubmittingForm(false))

    // display check or cross button on accordion 2
    let newIsSubmitted = {...oldPromoForm}
    newIsSubmitted[formName] = true
    yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted))

    // if not in update mode
    // don't initialize third form if it was submitted so that saved data is not resetted after previous
    if (!detailPromo && !oldPromoForm.reward) {
      yield call(fillFormReward)
    }
    yield put(actPromo.setAccordionActiveKey('3'))
  }
}

export function* onChangeItemPRBuyXGetYFlow (request) {
  const {formValue, formName, selectedOutlets, oldVariants} = request.payload
  try {
    yield put(act.showProgressBar())

    yield put(change('purchaseRequirement', formName, formValue))

    const response = yield call(apiPromo.getIntersectedItemVariants, formValue, selectedOutlets)
    let newVariants = {...oldVariants}
    let optionVariants = _.sortBy(response.data.variants)
    let arrVariants = null

    // This code will validate if have variant or not and inject all variant
    if (optionVariants && optionVariants.length > 0 && optionVariants[0] !== '') {
      let injectedVariants = [...optionVariants]
      injectedVariants.splice(0, 0, 'All Variant')
      arrVariants = injectedVariants
    } else {
      arrVariants = ['All Variant']
    }

    newVariants[formValue] = arrVariants
    yield put(actPromo.setIntersectItemVariants(newVariants))
  } catch (e) {

  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* onChangeItemRewardBuyXGetYFlow (request) {
  const {formValue, fieldName, selectedOutlets, oldVariants} = request.payload
  try {
    yield put(act.showProgressBar())
    yield put(change('reward', fieldName, formValue))

    const response = yield call(apiPromo.getIntersectedItemVariants, formValue, selectedOutlets)
    let newVariants = {...oldVariants}
    let optionVariants = _.sortBy(response.data.variants)
    let arrVariants = null

    // This code will validate if have variant or not and inject all variant
    if (optionVariants && optionVariants.length > 0 && optionVariants[0] !== '') {
      let injectedVariants = [...optionVariants]
      injectedVariants.splice(0, 0, 'All Variant')
      arrVariants = injectedVariants
    } else {
      arrVariants = ['All Variant']
    }

    newVariants[formValue] = arrVariants
    yield put(actPromo.setIntersectItemVariants(newVariants))
  } catch (e) {

  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* onChangeSwitchDiscount () {
  yield put(change('reward', 'discountAmount', null))
}

export function* onSubmitThirdForm (request) {
  const {payload: {formName, oldPromoForm, detailPromo}} = request
  try {
    yield put(actPromo.setIsSubmittingForm(true))
  } catch (err) {

  } finally {
    yield put(actPromo.setIsSubmittingForm(false))

    // display check or cross button on accordion 3
    let newIsSubmitted = {...oldPromoForm}
    newIsSubmitted[formName] = true
    yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted))

    // if not in update mode
    if (!detailPromo && !oldPromoForm.promoConfig) {
      // initialize default value for 4th form
      yield call(fillFormPromoConfig)
    }
    yield put(actPromo.setAccordionActiveKey('4'))
  }
}

export function* onCreatePromoBuyXGetYFlow (request) {
  yield put(act.showProgressBar())

  const {typeAndConfig, purchaseRequirement, reward, isSubmitPromoForm, hashedOutlets} = request.payload
  let newPromoBuyXGetY = {...typeAndConfig}
  let prWrapper = []
  // validate purchase requirement based on purchase type
  if (purchaseRequirement.purchaseType === 'buyFromItem') {
    /**
     * validate data based on relation
     * if the relation is AND, than push object to array
     * otherwise (OR) push single object to array and pushed it back to collection of array
     */
    if (purchaseRequirement.relation === 'AND' || (purchaseRequirement.items.length === 1)) {
      let pr = []
      purchaseRequirement.items.map(eachPR => {
        let flag = eachPR.variantName === 'All Variant' || eachPR.variantName === 'no variant'
        let singleItem = {
          amount: parseInt(eachPR.quantity),
          requirement_type: flag ? 'ITEM' : 'ITEM_VARIANT',
          requirement_name: flag ? eachPR.name : `${eachPR.name}||${eachPR.variantName}`
        }
        pr.push(singleItem)
      })
      prWrapper.push(pr)
    } else if (purchaseRequirement.relation === 'OR') {
      purchaseRequirement.items.map(eachPR => {
        let flag = eachPR.variantName === 'All Variant' || eachPR.variantName === 'no variant'
        let pr = [{
          amount: parseInt(eachPR.quantity),
          requirement_type: flag ? 'ITEM' : 'ITEM_VARIANT',
          requirement_name: flag ? eachPR.name : `${eachPR.name}||${eachPR.variantName}`
        }]
        prWrapper.push(pr)
      })
    }
  } else if (purchaseRequirement.purchaseType === 'buyFromCategory') {
    let requirementValue = [{
      amount: parseInt(purchaseRequirement.categoryQuantity),
      requirement_type: 'CATEGORY',
      requirement_name: purchaseRequirement.categoryName
    }]
    prWrapper.push(requirementValue)
  }
  // merge data
  newPromoBuyXGetY['requirements'] = prWrapper

  let rewardWrapper = []
  // validate reward based on reward type
  if (reward.rewardType === 'freeItem') {
    /**
     * validate data based on relation
     * if the relation is AND, than push object to array
     * otherwise (OR) push single object to array and pushed it back to collection of array
     */

    if (reward.relation === 'AND' || (reward.items.length === 1)) {
      let rewardCollection = []
      reward.items.map(value => {
        let flag = value.variantName === 'All Variant' || value.variantName === 'no variant'
        let singleItemReward = {
          amount: parseInt(value.quantity),
          reward_type: flag ? 'ITEM' : 'ITEM_VARIANT',
          reward_name: flag ? value.name : `${value.name}||${value.variantName}`
        }
        rewardCollection.push(singleItemReward)
      })
      rewardWrapper.push(rewardCollection)
    } else if (reward.relation === 'OR') {
      reward.items.map(value => {
        let flag = value.variantName === 'All Variant' || value.variantName === 'no variant'
        let singleItemReward = [{
          amount: parseInt(value.quantity),
          reward_type: flag ? 'ITEM' : 'ITEM_VARIANT',
          reward_name: flag ? value.name : `${value.name}||${value.variantName}`
        }]
        rewardWrapper.push(singleItemReward)
      })
    }
  } else if (reward.rewardType === 'discount') {
    let rewardValue = [{
      discount_type: reward.discountType ? 'PERCENTAGE' : 'CASH',
      discount: parseInt(reward.discountAmount)
    }]
    rewardWrapper.push(rewardValue)
  }
  // merge data
  newPromoBuyXGetY['rewards'] = rewardWrapper

  let flag = false
  let errorMessage = null
  try {
    let isDaySelected = newPromoBuyXGetY.days.find((day) => day === true)
    // show this error message if promo have time period and no day selected
    if (newPromoBuyXGetY.end_date && !isDaySelected) {
      yield put(actNotif.error('You must select at least 1 day'))
      yield put(actPromo.setAccordionActiveKey('4'))
    } else {
      const response = yield call(apiPromo.onCreateNewPromoBuyXGetY, newPromoBuyXGetY)
      if (response.data !== '') {
        flag = true
        errorMessage = response.data
      }
      if (flag) {
        let newIsSubmitted = {...isSubmitPromoForm}
        if (errorMessage.message.includes('already exists in business')) {
          newIsSubmitted['promoTypeAndName'] = false
          newIsSubmitted['promoConfig'] = true
          yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted))
          yield put(actNotif.error(`Promo must be unique`))
          yield put(actPromo.setAccordionActiveKey('1'))
          yield put(stopSubmit('promoTypeAndName', {
            promoName: 'Promo must be unique'
          }))
        } else if (errorMessage.message.includes('promo requirement')) {
          newIsSubmitted['purchaseRequirement'] = false
          newIsSubmitted['promoConfig'] = true
          yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted))
          yield put(actNotif.error(`This item already has a promo. Please choose different item to create the promo`))
          yield put(actPromo.setAccordionActiveKey('2'))
          let errorField = {}
          if (purchaseRequirement.purchaseType === 'buyFromItem') {
            const itemErrors = []
            purchaseRequirement.items.map((eachPR, index) => {
              itemErrors[index] = {
                name: 'Requirement must be unique'
              }
            })
            errorField.items = itemErrors
          } else {
            errorField.categoryName = 'Requirement must be unique'
          }
          yield put(stopSubmit('purchaseRequirement', errorField))
        }
      } else {
        yield put(actNotif.success(`"${newPromoBuyXGetY.name}" was successfully created.`))
        yield put(actPromo.closeRightColumn())
        yield put(actPromo.getListPromo({page: 0, per_page: 50}, hashedOutlets))
        yield put(reset('search')) // reset search bar after successfully create a new promo
      }
    }
  } catch (e) {

  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* listPromoRequest (request) {
  yield put(act.showProgressBar())
  yield put(showPageLoadingSpinner(true))
  const {payload: {params, hashedOutlet}} = request
  yield put(actPromo.setCurrentPage(0))
  try {
    let res = yield call(apiPromo.getPromoList, params)
    if (res.data) {
      let validPromo = []
      _.forEach(res.data, promo => {
        let validity = 0
        _.forEach(promo.outlet_ids, outletId => {
          validity += hashedOutlet[outletId] ? 1 : 0
        })
        if (validity > 0) {
          validPromo.push(promo)
        }
      })
      yield put(actPromo.setTotalPage(validPromo.length === 50 ? 1 : 0))
      if (validPromo.length > 0) {
        yield put(actPromo.setListPromo(validPromo))
      } else {
        yield put(actPromo.setListPromo([]))
      }
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(showPageLoadingSpinner(false))
    yield put(act.hideProgressBar())
  }
}

export function* clickRow (request) {
  const {payload: {promo, promoTypes, outlets}} = request

  // Reset all of the promo here
  yield put(reset('promoTypeAndName'))
  yield put(reset('promoAssignOutlet'))
  yield put(reset('purchaseRequirement'))
  yield put(reset('reward'))
  yield put(reset('promoConfig'))
  yield put(actPromo.setAccordionActiveKey('1'))

  const res = yield call(apiPromo.getDetailPromo, promo.id)
  const detailPromo = res.data
  yield put(actPromo.setDetailPromo(detailPromo))

  // initialize form promoTypeAndName
  const detailOutlets = outlets.map((out) => {
    let checkedOutlet = false
    if (detailPromo.outlet_ids.find((outlet) => outlet === out.id)) { checkedOutlet = true }
    return {
      id: out.id,
      name: out.name,
      checked: checkedOutlet,
      show: true
    }
  })

  yield put(initialize('promoTypeAndName', {
    promoType: promoTypes.find((type) => type.id === detailPromo.promo_type_id).name, // must match the value to the promo type name
    promoName: detailPromo.name,
    assignedOutlets: detailOutlets
  }))
  // initialize form promoAssignOutlet and selectedOutlets
  yield put(initialize('promoAssignOutlet', {selectedOutlets: detailOutlets}))
  yield put(actPromo.setSelectedOutlets(detailOutlets))

  // initialize form purchaseRequirement
  let type = ''
  let catAmount = 0
  let catName = ''
  let detailItems = []
  // if length of array is greather than 1 it means that it has OR relationship
  if (detailPromo.requirements.length > 1) {
    type = 'buyFromItem'
    detailPromo.requirements.map(req => {
      let reqName = req[0].requirement_name.split('||')
      detailItems.push({
        name: reqName[0],
        quantity: req[0].amount,
        variantName: reqName[1] || 'All Variant'
      })
    })
  } else {
    detailPromo.requirements.map((req, idx) => {
      if (req[idx].requirement_type === 'CATEGORY') {
        type = 'buyFromCategory'
        catName = req[idx].requirement_name
        catAmount = req[idx].amount
      } else {  // requirement_type = ITEM_VARIANT or ITEM
        type = 'buyFromItem'
        for (let i = 0; i < req.length; i++) {
          let reqName = req[i].requirement_name.split('||')
          detailItems.push({
            name: reqName[0],
            quantity: req[i].amount,
            variantName: reqName[1] || 'All Variant'
          })
        }
      }
    })
  }
  yield put(initialize('purchaseRequirement', {
    purchaseType: type,
    categoryQuantity: catAmount,
    categoryName: catName,
    items: detailItems,
    relation: detailPromo.requirements.length > 1 ? 'OR' : 'AND'
  }))

  // initialize reward
  let rewardType = null
  let discount = null
  let discType = null
  let detailItemsReward = []
  if (detailPromo.rewards.length > 1) {
    rewardType = 'freeItem'
    detailPromo.rewards.map(reward => {
      let rewName = reward[0].reward_name.split('||')
      detailItemsReward.push({
        name: rewName[0],
        quantity: reward[0].amount,
        variantName: rewName[1] || 'All Variant'
      })
    })
  } else {
    detailPromo.rewards.map((reward, idx) => {
      if (!reward[idx].reward_type) {  // for discount type
        discount = reward[idx].discount
        rewardType = 'discount'
        if (reward[idx].discount_type === 'PERCENTAGE') {
          discType = true
        } else {
          discType = ''
        }
      } else {
        rewardType = 'freeItem'
        for (let i = 0; i < reward.length; i++) {
          let reqName = reward[i].reward_name.split('||')
          detailItemsReward.push({
            name: reqName[0],
            quantity: reward[i].amount,
            variantName: reqName[1] || 'All Variant'
          })
        }
      }
    })
  }
  yield put(initialize('reward', {
    discountAmount: discount,
    rewardType: rewardType,
    discountType: discType,
    items: detailItemsReward,
    relation: detailPromo.rewards.length > 1 ? 'OR' : 'AND'
  }))

  // initialize promoConfig form
  // This flag to determine whether promo has time period or not
  let flag = !detailPromo.start_time && !detailPromo.end_time && !detailPromo.end_date
  // This function will collect all of the checked date
  const daysOfWeek = [
    {name: 'Sunday', isNotDisabled: false},
    {name: 'Monday', isNotDisabled: false},
    {name: 'Tuesday', isNotDisabled: false},
    {name: 'Wednesday', isNotDisabled: false},
    {name: 'Thursday', isNotDisabled: false},
    {name: 'Friday', isNotDisabled: false},
    {name: 'Saturday', isNotDisabled: false}
  ]
  detailPromo.days.map((day, index) => {
    daysOfWeek[index].checked = day ? true : ''
  })
  let isSelectAllDay = true
  for (let i = 0; i < 7; i++) {
    if (daysOfWeek[i].checked === '') {
      isSelectAllDay = ''
      break
    }
  }
  if (!flag) {
    let diff = moment(detailPromo.end_date).diff(detailPromo.start_date, 'days')
    let unblockedDay = 0
    let checkedDate = 0
    if (diff < 7) {
      for (let i = 0; i <= diff; i++) {
        let currDay = moment(detailPromo.start_date).add(i, 'days').format('dddd')
        let idx = _.findIndex(daysOfWeek, (day) => { return day.name === currDay })
        daysOfWeek[idx].isNotDisabled = true
        unblockedDay++
      }
    } else {
      daysOfWeek.forEach((day, idx) => { daysOfWeek[idx].isNotDisabled = true })
      unblockedDay = 7
    }
    daysOfWeek.forEach((day, idx) => {
      if (day.isNotDisabled && day.checked) {
        checkedDate++
      }
    })
    if (checkedDate !== unblockedDay) {
      isSelectAllDay = ''
    } else {
      isSelectAllDay = true
    }
  }
  yield put(initialize('promoConfig', {
    isAppliesToMultiple: detailPromo.multiple,
    isHaveTimePeriod: !flag,
    hoursFrom: !flag ? moment().hour(detailPromo.start_time / 60).minute(detailPromo.start_time % 60) : null,
    hoursTo: !flag ? moment().hour(detailPromo.end_time / 60).minute(detailPromo.end_time % 60) : null,
    date: {startDate: detailPromo.start_date, endDate: !flag ? detailPromo.end_date : detailPromo.end_date},
    days: daysOfWeek,
    selectAllDays: isSelectAllDay
  }))

  yield put(actPromo.openRightColumn())
}

export function* deletePromoRequest (request) {
  const {payload: {promo}} = request
  yield put(actPromo.setDeletedPromo(promo))
  yield put(actPromo.showDeleteModal())
}

export function* cancelDeletePromo () {
  yield put(actPromo.hideDeleteModal())
}

export function* deletePromo (request) {
  let {payload: {promoId, previousPromos}} = request
  let currentPromo = _.find(previousPromos, (promo) => { return promo.id === promoId })
  yield put(act.showProgressBar())
  try {
    yield call(apiPromo.deletePromo, promoId)
    const promos = []
    previousPromos.forEach((promo) => {
      if (promo.id !== promoId) {
        promos.push(promo)
      }
    })
    yield put(actPromo.setListPromo(promos))
    yield put(actPromo.setDetailPromo(null))
    yield put(actPromo.setDeletedPromo(null))
    yield put(actPromo.hideDeleteModal())
    yield put(actPromo.closeRightColumn())
    yield put(actNotif.success(`"${currentPromo.name}" successfully deleted.`))
    yield put(reset('search'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* deactivatePromoRequest (request) {
  const {payload: {promo}} = request
  yield put(actPromo.setDeactivatedPromo(promo))
  yield put(actPromo.showDeactivateModal())
}

export function* cancelDeactivatePromo () {
  yield put(actPromo.hideDeactivateModal())
}

export function* deactivatePromo (request) {
  const {payload: {promo, hashedOutlets}} = request
  yield put(act.showProgressBar())
  try {
    let newData = {
      active: false,
      added_outlet_ids: [],
      deleted_outlet_ids: [],
      days: promo.days,
      multiple: promo.multiple,
      name: promo.name,
      start_date: promo.start_date,
      end_date: _.has(promo, 'end_date') ? promo.end_date : null,
      start_time: _.has(promo, 'start_time') ? promo.start_time : null,
      end_time: _.has(promo, 'end_time') ? promo.end_time : null
    }
    yield call(apiPromo.updatePromo, promo.id, newData)
    yield put(actPromo.getListPromo({page: 0, per_page: 50}, hashedOutlets))
    yield put(actPromo.setDeactivatedPromo(null))
    yield put(actPromo.hideDeactivateModal())
    yield put(actPromo.closeRightColumn())
    yield put(actNotif.success(`"${promo.name}" successfully deactivated.`))
    yield put(actPromo.setDetailPromo(null))
    yield put(reset('search')) // reset searchbar after successfully deactivate promo
  } catch (err) {
    yield put(actNotif.error(err.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* reactivatePromoRequest (request) {
  const {payload: {promo}} = request
  yield put(actPromo.setReactivatedPromo(promo))
  yield put(actPromo.showReactivateModal())
  const daysOfWeek = [
    {name: 'Sunday', isNotDisabled: false},
    {name: 'Monday', isNotDisabled: false},
    {name: 'Tuesday', isNotDisabled: false},
    {name: 'Wednesday', isNotDisabled: false},
    {name: 'Thursday', isNotDisabled: false},
    {name: 'Friday', isNotDisabled: false},
    {name: 'Saturday', isNotDisabled: false}
  ]
  promo.days.map((day, index) => {
    daysOfWeek[index].checked = day ? true : ''
  })
  let isSelectAllDay = true
  let diff = moment(promo.end_date).diff(promo.start_date, 'days')
  let unblockedDay = 0
  let checkedDate = 0
  if (diff < 7) {
    for (let i = 0; i <= diff; i++) {
      let currDay = moment(promo.start_date).add(i, 'days').format('dddd')
      let idx = _.findIndex(daysOfWeek, (day) => { return day.name === currDay })
      daysOfWeek[idx].isNotDisabled = true
      unblockedDay++
    }
  } else {
    daysOfWeek.forEach((day, idx) => { daysOfWeek[idx].isNotDisabled = true })
    unblockedDay = 7
  }
  daysOfWeek.forEach((day, idx) => {
    if (day.isNotDisabled && day.checked) {
      checkedDate++
    }
  })
  if (checkedDate !== unblockedDay) {
    isSelectAllDay = ''
  } else {
    isSelectAllDay = true
  }
  yield put(initialize('reactivateForm', {
    days: daysOfWeek,
    hoursFrom: promo.start_time ? moment().hour(promo.start_time / 60).minute(promo.start_time % 60) : moment().startOf('day'),
    hoursTo: promo.end_time ? moment().hour(promo.end_time / 60).minute(promo.end_time % 60) : moment().endOf('day'),
    date: {
      startDate: promo.start_date ? promo.start_date : moment().startOf('day').toISOString(),
      endDate: promo.end_date ? promo.end_date : moment().endOf('day').toISOString()
    },
    selectAllDays: isSelectAllDay
  }))
}

export function* cancelReactivatePromo () {
  yield put(actPromo.hideReactivateModal())
}

export function* reactivatePromo (request) {
  const {payload: {promo, data, hashedOutlets}} = request
  yield put(act.showProgressBar())
  try {
    const newDays = data.days.map((day) => {
      return day.checked
    })

    let currentMoment = moment().startOf('day')
    let startTime = moment(data.hoursFrom).diff(currentMoment, 'minutes')
    let endTime = moment(data.hoursTo).diff(currentMoment, 'minutes')

    let newData = {
      name: promo.name,
      active: true,
      start_date: data.date.startDate,
      end_date: data.date.endDate,
      start_time: startTime,
      end_time: endTime,
      days: newDays,
      added_outlet_ids: [],
      deleted_outlet_ids: [],
      multiple: promo.multiple
    }

    let isDaySelected = newData.days.find((day) => day === true)

    if (newData.end_date && !isDaySelected) {
      // show this error message if promo have time period and no day selected
      yield put(actNotif.error('You must select at least 1 day'))
    } else {
      yield call(apiPromo.updatePromo, promo.id, newData)
      yield put(actPromo.getListPromo({page: 0, per_page: 50}, hashedOutlets))
      yield put(reset('search'))
      yield put(actPromo.hideReactivateModal())
      yield put(actPromo.closeRightColumn())
      yield put(actNotif.success(`"${promo.name}" was successfully activated.`))
      yield put(actPromo.setReactivatedPromo(null))
      yield put(actPromo.setDetailPromo(null))
    }
  } catch (err) {
    yield put(actNotif.error(err.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* onSubmitUpdate (request) {
  const {payload: {promoId, updatedData, hashedOutlets, isDaySelected, isHaveTimePeriod}} = request
  yield put(act.showProgressBar())
  try {
    if (isHaveTimePeriod && !isDaySelected) {
      // show this error message if promo have time period and no day selected
      yield put(actNotif.error('You must select at least 1 day'))
    } else if (updatedData.name.length > 25) {
      yield put(actNotif.error('The maximum character of promo name is 25'))
      yield put(actPromo.setAccordionActiveKey('1'))
      yield put(stopSubmit('promoTypeAndName', {
        promoName: 'The maximum character of promo name is 25'
      }))
    } else {
      const response = yield call(apiPromo.updatePromo, promoId, updatedData)
      const {status} = response.data
      if (status >= 400) {
        yield put(actNotif.error('Promo name must be unique'))
        yield put(actPromo.setAccordionActiveKey('1'))
        yield put(stopSubmit('promoTypeAndName', {
          promoName: 'Promo must be unique'
        }))
      } else {
        yield put(actPromo.getListPromo({page: 0, per_page: 50}, hashedOutlets))
        yield put(actPromo.closeRightColumn())
        yield put(actNotif.success(`"${updatedData.name}" was successfully updated`))
        yield put(actPromo.setDetailPromo(null))
        yield put(reset('search'))
      }
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* cancelConfirmReactivatePromo () {
  yield put(actPromo.hideConfirmReactivateModal())
}

export function* confirmReactivatePromo (request) {
  const {payload: {promo, hashedOutlets}} = request
  yield put(act.showProgressBar())
  try {
    let newData = {
      active: true,
      added_outlet_ids: [],
      deleted_outlet_ids: [],
      days: promo.days,
      multiple: promo.multiple,
      name: promo.name,
      start_date: promo.start_date,
      end_date: null,
      start_time: null,
      end_time: null
    }
    yield call(apiPromo.updatePromo, promo.id, newData)
    yield put(actPromo.getListPromo({page: 0, per_page: 50}, hashedOutlets))
    yield put(actPromo.hideConfirmReactivateModal())
    yield put(actPromo.closeRightColumn())
    yield put(actNotif.success(`"${promo.name}" was successfully activated.`))
    yield put(reset('search'))
    yield put(actPromo.setDetailPromo(null))
  } catch (err) {
    yield put(actNotif.error(err.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* onChangePromoTypeFlow (request) {
  yield put(actPromo.setListPromo([]))
  yield put(showPageLoadingSpinner(true))   // set false by listPromoRequest saga
  const {promoTypeId, status, keyword, hashedOutlets} = request.payload
  let params = {
    promo_type_id: promoTypeId,
    state: status,
    keyword: keyword,
    page: 0, // make this dynamic
    per_page: 50
  }
  yield put(actPromo.getListPromo(params, hashedOutlets))
}

export function* onChangeStatusFlow (request) {
  yield put(actPromo.setListPromo([]))
  yield put(showPageLoadingSpinner(true))
  const {promoTypeId, status, keyword, hashedOutlets} = request.payload
  let params = {
    promo_type_id: promoTypeId,
    state: status,
    keyword: keyword,
    page: 0, // make this dynamic
    per_page: 50
  }
  yield put(actPromo.getListPromo(params, hashedOutlets))
}

export function* onChangeKeyword (request) {
  yield put(actPromo.setListPromo([]))
  yield put(showPageLoadingSpinner(true))
  const {promoTypeId, status, keyword, hashedOutlets} = request.payload
  let params = {
    promo_type_id: promoTypeId,
    state: status,
    keyword: keyword,
    page: 0, // make this dynamic
    per_page: 50
  }
  yield put(actPromo.getListPromo(params, hashedOutlets))
}

export function* onReachButtomFlow (request) {
  const {oldPromo, queryParams} = request.payload
  try {
    yield put(act.showProgressBar())
    const response = yield call(apiPromo.getPromoList, queryParams)
    const newPromoList = oldPromo.concat(response.data)
    yield put(actPromo.setCurrentPage(queryParams.page))
    if (response.data.length === 50) {
      yield put(actPromo.setTotalPage(queryParams.page + 1))
    }
    yield put(actPromo.setListPromo(newPromoList))
  } catch (e) {

  } finally {
    yield put(act.hideProgressBar())
  }
}

export function* askConfirmUpdateFlow (request) {
  const {payload: {nextUpdateAction}} = request
  yield put(actPromo.setNextUpdateAction(nextUpdateAction))
  yield put(actPromo.showUpdateConfirmationModal())
}

export function* confirmUpdateFlow (request) {
  const {payload: {nextUpdateAction}} = request
  yield put(actPromo.setNextUpdateAction(null))
  yield put(actPromo.hideUpdateConfirmationModal())
  yield put(nextUpdateAction)
  yield put(actPromo.setActionUpdateName(''))
}

export function* cancelConfirmUpdateFlow () {
  yield put(actPromo.setNextUpdateAction(null))
  yield put(actPromo.hideUpdateConfirmationModal())
}

export default function* saga () {
  yield takeLatest(LIBRARY_PROMO_PAGE_REQUEST, pageRequest)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_CREATE_PROMO, clickCreatePromo)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO, clickCancel)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET, clickAssignOutlet)
  yield takeLatest(LIBRARY_PROMO_SEARCH_OUTLET, searchOutletOnModal)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL, clickCancelModal)
  yield takeLatest(LIBRARY_PROMO_SELECT_ALL_OUTLETS, selectAllOutletsModal)
  yield takeLatest(LIBRARY_PROMO_UNSELECT_ALL_OUTLETS, unselectAllOutletsModal)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL, confirmAssignOutlet)
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM, onSubmitEachPromoFormFlow)
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM, onSubmitFirstForm)
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y, onChangeItemPRBuyXGetYFlow)
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM, onSubmitSecondForm)
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y, onChangeItemRewardBuyXGetYFlow)
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT, onChangeSwitchDiscount)
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM, onSubmitThirdForm)
  yield takeLatest(LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y, onCreatePromoBuyXGetYFlow)
  yield takeLatest(LIBRARY_PROMO_GET_LIST_PROMO_REQUEST, listPromoRequest)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_ROW, clickRow)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_DELETE, deletePromoRequest)
  yield takeLatest(LIBRARY_PROMO_CANCEL_DELETE, cancelDeletePromo)
  yield takeLatest(LIBRARY_PROMO_DELETE_PROMO, deletePromo)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_DEACTIVATE, deactivatePromoRequest)
  yield takeLatest(LIBRARY_PROMO_CANCEL_DEACTIVATE, cancelDeactivatePromo)
  yield takeLatest(LIBRARY_PROMO_DEACTIVATE_PROMO, deactivatePromo)
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_REACTIVATE, reactivatePromoRequest)
  yield takeLatest(LIBRARY_PROMO_CANCEL_REACTIVATE, cancelReactivatePromo)
  yield takeLatest(LIBRARY_PROMO_REACTIVATE_PROMO, reactivatePromo)
  yield takeLatest(LIBRARY_PROMO_UPDATE_PROMO, onSubmitUpdate)
  yield takeLatest(LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE, cancelConfirmReactivatePromo)
  yield takeLatest(LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO, confirmReactivatePromo)
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES, onChangePromoTypeFlow)
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_STATUS, onChangeStatusFlow)
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_KEYWORD, onChangeKeyword)
  yield takeLatest(LIBRARY_PROMO_ON_REACH_BUTTOM, onReachButtomFlow)
  yield takeLatest(LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE, askConfirmUpdateFlow)
  yield takeLatest(LIBRARY_PROMO_ON_CONFIRM_UPDATE, confirmUpdateFlow)
  yield takeLatest(LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION, cancelConfirmUpdateFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/library/promo.js